import * as React from "react";

export const BallOutline = ({ className = "w-4 h-4" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    className={className}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
    <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
    <path d="M12 2v7m0 6v7m10-10h-7m-6 0H2m15.07 7.07l-4.24-4.24m-5.66 0l-4.24 4.24m0-10.14l4.24 4.24m5.66 0l4.24-4.24" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

export default BallOutline;
